/* eslint-disable @nx/enforce-module-boundaries */
import { CirclePlus } from '@mybridge/icons';
import {
  Button,
  Checkbox,
  FormControl,
  FormErrorMessage,
  FormLabel,
  HStack,
  Heading,
  Input,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Stack,
  Text,
  Textarea,
} from '@mybridge/ui';
import { forwardRef, useContext, useEffect, useState } from 'react';
import { Controller, useForm } from 'react-hook-form';
import { DateSelect } from 'v4/components/date-select';
import { DegreesDropdown } from 'v4/components/degrees-dropdown';
import { CoursesDropdown } from "v4/components/concentration-dropdown";
import { SchoolsDropdown } from 'v4/components/schools-dropdown';
import { UniversitiesDropdown } from 'v4/components/university-dropdown';
import { MyProfileContext } from '../context';
import moment from 'moment';
import { formatCommaSeparated } from 'v4/lib/commons';
import { useDisclosure } from '@mybridge/ui';
import { CreateAudiencePermissionModal } from '../audience-modal-create';
import { EarthGlobeIcon, OnlyMeLockIcon, TeamIcon } from '@mybridge/icons';
import { useTranslator } from '@mybridge/ui/custom-hooks/useTranslation';
import { Box } from '@chakra-ui/react';
import { useNumberFormatter } from '@mybridge/ui/custom-hooks/useNumberFormatter';
export const MyProfileEducationModal = forwardRef(({ ...props }, ref) => {
  const {
    educationDisc,
    addEducation,
    addEducationLoading,
    updateEducationLoading,
    selectedEducation,
    setSelectedEducation,
    updateEducation,
    removeEducation,
    removeEducationLoading,
    isDateAfter,
    type,
    setType,
  } = useContext(MyProfileContext);
  const { t } = useTranslator();
  const audienceCreateDisc = useDisclosure();
  const [audienceValue, setAudienceValue] = useState(1);
  const [descCharCount, setDescCharCount] = useState(0);
  const [descError, setDescError] = useState('');
  const {formatNumber}=useNumberFormatter();
  const education = {
    ...(selectedEducation ?? {}),
    startDate: {
      month: selectedEducation?.start_month ? parseInt(selectedEducation?.start_month) : '0',
      year: selectedEducation?.start_year,
    },
    endDate: {
      month: selectedEducation?.end_month ? parseInt(selectedEducation?.end_month) : '0',
      year: selectedEducation?.end_year,
    },
  };


  useEffect(() => {
    if (education?.type) {
      setType(education?.type);
    }
  }, [education]);

  // Add useEffect to initialize character count from existing description
  useEffect(() => {
    if (selectedEducation?.desc) {
      setDescCharCount(selectedEducation.desc.length);
    }
  }, [selectedEducation?.desc]);

  // Add handler for description change
  const handleDescriptionChange = (e) => {
    const value = e.target.value;
    setDescCharCount(value.length);

    if (value.length === 500) {
      setDescError(t('otherModules.characterLimitExceeded') || 'Description cannot exceed 500 characters');
    } else {
      setDescError('');
    }
  };
  const {
    register,
    handleSubmit,
    control,
    watch,
    formState: { errors },
  } = useForm({
    defaultValues: education ?? {},
  });

  const endDate = watch('endDate');

  const isFutureEndDate = endDate?.month !== undefined && endDate?.year !== undefined && (() => {
    const today = new Date();
    const end = new Date(endDate.year, endDate.month - 1);
    return end > today;
  })();

  const onSubmit = async (form) => {
    // console.log(form);
    const form_ = {
      ...(form ?? {}),
      start_month: form?.startDate?.month,
      start_year: form?.startDate?.year,
      end_month: form?.endDate?.month,
      end_year: form?.endDate?.year,
      audience: audienceValue,
    };
    if (selectedEducation?.id) {
      await updateEducation({ ...(form_ ?? {}), id: selectedEducation?.id, type });
      setSelectedEducation();
    } else {
      addEducation({ ...(form_ ?? {}), type });
    }
  };

  const onClose = () => {
    educationDisc?.onClose();
    setSelectedEducation?.(null);
  };

  const toggleType = () => {
    setType(type === 'School' ? 'College' : 'School');
  };
  const renderPermissionSwitch = (param) => {
    switch (param) {
      case 1:
        return {
          icon: <EarthGlobeIcon width="16px" height="16px" />,
          text: t('profileDetails.public') || 'Public',
        };
      case 2:
        return {
          icon: <TeamIcon width="16px" height="16px" />,
          text: t('profileDetails.myNetwork') || 'myNetwork',
        };
      case 3:
        return {
          icon: <OnlyMeLockIcon width="16px" height="16px" />,
          text: t('profileDetails.onlyMe') || 'Only me',
        };
      default:
        return {
          icon: <EarthGlobeIcon width="16px" height="16px" />,
          text: t('profileDetails.public') || 'Public',
        };
    }
  };
  return (
    // <Modal size="xl" {...(educationDisc ?? {})} onClose={onClose}>
    //   <ModalOverlay />
    //   <ModalContent>

    //   </ModalContent>
    // </Modal>
    <>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Heading
          fontSize="18px"
          color="brandPrimary.500"
          fontWeight="400"
          mb={4}
        >
          {t('education.education') || 'Education'}
        </Heading>
        {/* <ModalBody> */}
        {selectedEducation?.id ? (
          ''
        ) : (
          <HStack cursor="pointer" onClick={toggleType} pb={2} mb={2}>
            <CirclePlus />
            <Text>{type === 'School' ? 'Add College' : 'Add School'}</Text>
          </HStack>
        )}

        {/* School */}
        {type === 'School' ? (
          <>
            <Heading mb={3} size="md">
              {t('education.highSchool') || 'High school'}
            </Heading>
            <Stack spacing={4}>
              <FormControl isInvalid={errors?.name} variant="floating">
                <Controller
                  control={control}
                  render={({ field }) => (
                    <SchoolsDropdown
                      allowCreate
                      {...field}
                      onChange={(item) => field?.onChange?.(item?.name)}
                      variant="whiteInput"
                      defaultValue={education?.name}
                    >
                      {(input) => (
                        <Input
                          {...(input ?? {})}
                          onClick={(e) => input?.disc?.onOpen?.()}
                          onChange={(e) => input?.onChange(e.target.value)}
                          placeholder={t('profileDetails.typeToSearch') || 'Type to search...'}
                          variant="whiteInput"
                        />
                      )}
                    </SchoolsDropdown>
                  )}
                  rules={{ required: true }}
                  name="name"
                />
                <FormLabel>{t('education.schoolName') || 'School Name'}</FormLabel>
                <FormErrorMessage>{t('education.schoolRequired') || 'School is required'}</FormErrorMessage>
              </FormControl>

              <FormControl isInvalid={errors?.startDate || errors?.endDate}>
                <FormLabel>{t('education.timePeriod') || 'Time period'}</FormLabel>
                <HStack>
                  <Controller
                    control={control}
                    render={({ field }) => (
                      <DateSelect variant="floating" flex={1} {...field} />
                    )}
                    rules={{ required: false }}
                    name="startDate"
                  />
                  <Text>to</Text>
                  <Controller
                    control={control}
                    render={({ field }) => (
                      <DateSelect variant="floating" flex={1} {...field} />
                    )}
                    rules={{
                      required: false,
                      validate() {
                        return isDateAfter(
                          watch('startDate')?.month,
                          watch('startDate')?.year,
                          watch('endDate')?.month,
                          watch('endDate')?.year
                        );
                      },
                    }}
                    name="endDate"
                  />
                </HStack>
                <FormErrorMessage>
                  {t('education.validTimePeriod') || 'Please select a valid time period'}
                </FormErrorMessage>
              </FormControl>
              <FormControl>
                {/* <Checkbox {...register('is_graduate')}>{t('education.graduated') || 'Graduated'}</Checkbox> */}
                <Checkbox {...register('is_graduate')} isDisabled={isFutureEndDate}>
                  {t('education.graduated') || 'Graduated'}
                </Checkbox>
              </FormControl>
              {/* <FormControl variant="floating">
                <Textarea
                  placeholder=" "
                  variant="outline"
                  {...register('desc')}
                />
                <FormLabel>{t('profileExperience.description') || "Description"}</FormLabel>
              </FormControl> */}
              <FormControl variant="floating" isInvalid={!!descError}>
                <Textarea
                  placeholder=" "
                  variant="outline"
                  maxLength={500}
                  {...register('desc', {
                    onChange: handleDescriptionChange,
                    validate: (value) => {
                      if (value && value.length > 500) {
                        return t('otherModules.characterLimitExceeded');
                      }
                      return true;
                    }
                  })}
                />
                <FormLabel>{t('profileExperience.description') || "Description"}</FormLabel>
                <Box mt={1} fontSize="sm" color="gray.500" textAlign="right">
                  {/* {descCharCount}/500 */}
                  {formatNumber(descCharCount)}/{formatNumber(500)}
                  
                </Box>
                {descError && (
                  <FormErrorMessage>{descError}</FormErrorMessage>
                )}
              </FormControl>
            </Stack>
          </>
        ) : (
          <>
            <Heading mb={3} size="md">
              {t('education.university') || 'University'}
            </Heading>
            <Stack spacing={4}>
              <FormControl isInvalid={errors?.name} variant="floating">
                <Controller
                  control={control}
                  render={({ field }) => (
                    <UniversitiesDropdown
                      allowCreate
                      {...field}
                      onChange={(item) => field?.onChange?.(item?.name)}
                      variant="whiteInput"
                    >
                      {(input) => (
                        <>
                          <Input
                            {...(input ?? {})}
                            onClick={(e) => input?.disc?.onOpen?.()}
                            onChange={(e) => input?.onChange(e.target.value)}
                            placeholder={t('profileDetails.typeToSearch') || 'Type to search...'}
                            variant="whiteInput"
                          />
                          {/* Hide FormLabel if the dropdown is open */}
                          <FormLabel
                            style={{
                              display: input?.disc?.isOpen ? 'none' : 'block',
                            }}
                          >
                            {t('education.university') || 'University'}*
                          </FormLabel>
                        </>
                      )}
                    </UniversitiesDropdown>
                  )}
                  rules={{ required: true }}
                  name="name"
                />

                <FormErrorMessage>{t('education.universityRequired') || 'University is required'}</FormErrorMessage>
              </FormControl>

              <FormControl
                variant="floating"
              // isInvalid={errors?.degree}
              >
                <Controller
                  control={control}
                  render={({ field }) => (
                    <DegreesDropdown
                      allowCreate
                      {...field}
                      onChange={(item) => field?.onChange?.(item?.name)}
                    >
                      {(input) => (
                        <>
                          <Input
                            {...(input ?? {})}
                            onClick={(e) => input?.disc?.onOpen?.()}
                            onChange={(e) => input?.onChange(e.target.value)}
                            placeholder=" "
                          />
                          {/* Hide FormLabel if the dropdown is open */}
                          <FormLabel
                            style={{
                              display: input?.disc?.isOpen ? 'none' : 'block',
                            }}
                          >
                            {t('education.degree') || 'Degree'}
                          </FormLabel>
                        </>
                      )}
                    </DegreesDropdown>
                  )}
                  // rules={{ required: true }}
                  name="degree"
                />
                <FormErrorMessage>{t('education.degreeRequired') || 'Degree is required'}</FormErrorMessage>
              </FormControl>
              <FormControl variant="floating">
                <Stack>
                  <Controller
                    control={control}
                    render={({ field }) => (
                      <CoursesDropdown
                        allowCreate
                        {...field}
                        onChange={(item) => field?.onChange?.(item?.name)}
                      >
                        {(input) => (
                          <>
                            <Input
                              {...(input ?? {})}
                              onClick={(e) => input?.disc?.onOpen?.()}
                              onChange={(e) => input?.onChange(e.target.value)}
                              placeholder=" "
                            />
                            {/* Hide FormLabel if the dropdown is open */}
                            <FormLabel
                              style={{
                                display: input?.disc?.isOpen ? 'none' : 'block',
                              }}
                            >
                              {t('education.concentration') || 'Concentration'}
                            </FormLabel>
                          </>
                        )}
                      </CoursesDropdown>
                    )}
                    // rules={{ required: true }}
                    name="courses"
                  />
                  <FormErrorMessage>{t('education.coursesRequired') || 'Courses is required'}</FormErrorMessage>
                </Stack>


              </FormControl>
              <FormControl>
                {/* <Checkbox {...register('is_graduate')}>{t('education.graduated') || 'Graduated'}</Checkbox> */}
                <Checkbox {...register('is_graduate')} isDisabled={isFutureEndDate}>
                  {t('education.graduated') || 'Graduated'}
                </Checkbox>
              </FormControl>
              <FormControl isInvalid={errors?.startDate || errors?.endDate}>
                <FormLabel>{t('education.timePeriod') || 'Time period'}</FormLabel>
                <HStack>
                  <Controller
                    control={control}
                    render={({ field }) => (
                      <DateSelect variant="floating" flex={1} {...field} />
                    )}
                    rules={{ required: false }}
                    name="startDate"
                  />
                  <Text>to</Text>
                  <Controller
                    control={control}
                    render={({ field }) => (
                      <DateSelect variant="floating" flex={1} {...field} />
                    )}
                    rules={{
                      required: false,
                      validate() {
                        return isDateAfter(
                          watch('startDate')?.month,
                          watch('startDate')?.year,
                          watch('endDate')?.month,
                          watch('endDate')?.year
                        );
                      },
                    }}
                    name="endDate"
                  />
                </HStack>
                <FormErrorMessage>
                  {t('education.validTimePeriod') || 'Please select a valid time period'}
                </FormErrorMessage>
              </FormControl>
              {/* <FormControl variant="floating">
                <Textarea
                  placeholder=""
                  variant="outline"
                  {...register('desc')}
                />
                <FormLabel>{t('profileExperience.description') || "Description"}</FormLabel>
              </FormControl> */}
              <FormControl variant="floating" isInvalid={!!descError}>
                <Textarea
                  placeholder=""
                  variant="outline"
                  maxLength={500}
                  {...register('desc', {
                    onChange: handleDescriptionChange,
                    validate: (value) => {
                      if (value && value.length > 500) {
                        return t('otherModules.characterLimitExceeded');
                      }
                      return true;
                    }
                  })}
                />
                <FormLabel>{t('profileExperience.description') || "Description"}</FormLabel>
                <Box mt={1} fontSize="sm" color="gray.500" textAlign="right">
                  {descCharCount}/500
                </Box>
                {descError && (
                  <FormErrorMessage>{descError}</FormErrorMessage>
                )}
              </FormControl>
            </Stack>
          </>
        )}
        {/* </ModalBody>
    <ModalFooter> */}
        <HStack flex={1} mt={4}>
          <HStack flex={1} justifyContent="flex-start">
            <Button
              borderRadius="50px"
              leftIcon={renderPermissionSwitch(audienceValue)?.icon}
              type="button"
              onClick={() => {
                audienceCreateDisc.onOpen();
              }}
            >
              {renderPermissionSwitch(audienceValue)?.text}
            </Button>
            {selectedEducation?.id ? (
              <Button
                borderRadius="50px"
                onClick={(e) => removeEducation(selectedEducation)}
                isLoading={removeEducationLoading}
                color="red.500"
                variant="ghost"
              >
                {t('buttons.delete') || "Delete"}
              </Button>
            ) : (
              ''
            )}
          </HStack>

          <HStack flex={1} justifyContent="flex-end">
            <Button
              borderRadius="50px"
              onClick={(e) => {
                educationDisc?.onClose?.();
                setSelectedEducation();
              }}
              variant="secondary"
            >
              {t('buttons.cancel') || "Cancel"}
            </Button>
            <Button
              borderRadius="50px"
              isLoading={addEducationLoading || updateEducationLoading}
              type="submit"
              variant="primary"
            >
              {t('buttons.save') || "Save"}
            </Button>
          </HStack>
        </HStack>
        {/* </ModalFooter> */}
      </form>
      {audienceCreateDisc?.isOpen ? (
        <CreateAudiencePermissionModal
          {...audienceCreateDisc}
          setPermissionValue={(e) => setAudienceValue(e)}
        />
      ) : (
        ''
      )}
    </>
  );
});
